import React, { useState } from 'react';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PlayerTile } from './PlayerTile';

export function LineupPicker({ team, players, onCancel, onConfirm, title, initialSelected }) {
  const [selectedIds, setSelectedIds] = useState(() => (initialSelected || []).slice(0, 5));
  const toggle = (pid) => {
    setSelectedIds((prev) => {
      if (prev.includes(pid)) return prev.filter(x => x !== pid);
      if (prev.length >= 5) {
        toast.error('Only 5 starters allowed — tap one to remove first');
        return prev;
      }
      return [...prev, pid];
    });
  };
  return (
    <div className="fixed inset-0 z-[110] bg-[#0A0F2C] flex flex-col" data-testid="lineup-picker">
      <div className="flex items-center justify-between px-4 py-3 bg-[#00247D] border-b border-white/10">
        <Button variant="ghost" size="sm" onClick={onCancel} className="text-white/80 hover:text-white hover:bg-white/10" data-testid="lineup-cancel-btn">
          <ArrowLeft className="w-4 h-4 mr-1.5" /> Game Settings
        </Button>
        <div className="text-white text-base sm:text-lg font-semibold">
          {title || 'Starting Lineup'} · <span className="text-amber-300">{team.name}</span>
        </div>
        <Button size="sm"
          onClick={() => onConfirm(selectedIds)}
          disabled={selectedIds.length !== 5}
          className="bg-amber-400 hover:bg-amber-300 text-[#00247D] font-black h-8 px-4 disabled:opacity-30"
          data-testid="lineup-done-btn">
          {selectedIds.length === 5 ? 'Done' : `Pick ${5 - selectedIds.length} more`}
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto p-3 sm:p-5">
        {players.length === 0 ? (
          <div className="text-center text-white/60 py-12">
            No players on roster for this team yet. Add them from the event roster manager first.
          </div>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-3 max-w-5xl mx-auto">
            {players.map(p => (
              <PlayerTile
                key={p.id}
                player={p}
                selected={selectedIds.includes(p.id)}
                onClick={() => toggle(p.id)}
                testId={`lineup-player-${p.id}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
